export default __webpack_public_path__ + "static/media/navbar-managers-orange.3e58c58b.svg";